﻿class OpenPersonModal {
    constructor() {
        $('.open-person-popup').magnificPopup({
            type: 'iframe',
            closeOnContentClick: true,
            mainClass: 'modal modal--person',
            image: {
                verticalFit: true
            },
            callbacks: {
                open: function() {
                    //$.magnificPopup.close();
                }
            }
        });
    }
}

export default OpenPersonModal;